<template>
  <div class="rc-scan-success" v-if="checkInData">
    <div class="rc-container">
      <div class="code-container">
        <div class="code">
          <div class="rc-count-checkin">
            {{
              $t('scan-success-page.check-in-notify', {
                split: '/'
              })
            }}
          </div>

          <div class="entry-code">
            <v-btn
              large
              class="code-btn"
              :color="
                getColorCodeFromJapaneseLevel(
                  checkInData !== null &&
                    checkInData.applicant_entry !== null &&
                    checkInData.applicant_entry.data.jlpt_level
                )
              "
              >{{ checkInData !== null && checkInData.entry_no }}
            </v-btn>
          </div>

          <div class="code-info">
            <div class="name-applicant">
              {{ applicantName }}
            </div>
            <router-link tag="button" :to="pathHome + '/' + fromRoute">
              <v-btn color="#e8320d" height="50">
                {{
                  $t('scan-success-page.continue-check-in', {
                    split: '/'
                  })
                }}
              </v-btn>
            </router-link>
            <router-link tag="button" :to="pathHome + '/top'">
              <v-btn
                class="btn-code"
                outlined
                color="#e8320e"
                height="50"
                v-html="
                  $t('scan-success-page.back-to-top-page', {
                    split: '/'
                  })
                "
              >
              </v-btn>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Receptionist-Success',

  watch: {
    checkInData: function (val, oldVal) {
      if (val === null) {
        this.$router.push({ name: 'code-scan' });
      }

      return val;
    },

    $route: function (val) {
      if (val) {
        console.log(val);
      }
    }
  },

  created() {
    if (this.$route.query !== null) {
      this.fromRoute =
        this.$route.query.type !== null ? this.$route.query.type : 'code-scan';
    }

    if (this.checkInData == null) {
      const { query } = this.$route;
      if (query.type !== null && query.type === 'code-scan') {
        this.$router.push({ name: 'code-scan' });
      } else if (query.type !== null && query.type === 'qr-scan') {
        this.$router.push({ name: 'qr-scan' });
      } else {
        this.$router.push({ name: 'code-scan' });
      }
    }
  },

  computed: {
    ...mapGetters({
      checkInData: 'getCheckInData'
    }),

    applicantName: function () {
      let name = 'null';

      if (this.checkInData !== null) {
        const { applicant_name } = this.checkInData;

        if (applicant_name !== null) {
          name = applicant_name;
        }
      }

      return name;
    }
  },

  methods: {
    getColorCodeFromJapaneseLevel: function (jlpt_level) {
      const arr = this.c_japanese_level.filter((ele) => ele.id == jlpt_level);

      if (arr.length > 0) {
        return '#' + arr[0].color_code;
      } else return JAPANESE_COLOR_DEFAULT;
    }
  }
};
</script>

<style lang="scss">
@import '@/style/common.scss';
@import '@/style/devices.scss';

.rc-scan-success {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;

  .rc-container {
    width: 80vw;
    margin-top: 50px;

    .rc-datetime {
      color: #e8320d;
      font-size: 14px;
      text-align: center;
    }

    .rc-count-checkin {
      color: #e8320d;
      font-size: 16px;
      text-align: center;
      margin: 10px auto;
    }

    .rc-count-checkin-icon {
      display: none;
      color: #e8320d;
      font-size: 14px;
      text-align: center;
      margin: 10px auto;
    }

    .code-container {
      background: $secondary_blue;
      padding: 24px 0;
      display: flex;
      justify-content: center;

      .code {
        background: #fff;
        border-radius: 10px;
        border: 1px dashed $bold_blue;
        padding: 34px 60px;
        position: relative;
        z-index: 0;
        width: 140% !important;
        max-width: 550px;

        h3 {
          padding-bottom: 22px;
          border-bottom: 1px dashed $bold_blue;
        }

        .entry-code {
          margin-top: 100px;
          height: 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .code-btn {
            color: #fff;
            width: 90%;
            height: 70px;
            font-weight: 900;
            font-size: 40px;
          }
        }

        .code-info {
          height: 35vh;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          margin-top: 100px;

          .name-applicant {
            height: 100px;
            font-weight: 600;
          }

          .v-btn {
            width: 350px;
            height: 50px;
            color: #fff;
            text-transform: unset !important;
          }

          .btn-code {
            margin-top: 50px;
          }

          .title {
            font-weight: 500;
            font-size: 14px !important;
            margin-top: 40px;
            text-align: center;
          }

          .qr-box {
            overflow: hidden;
            background: #fff;
            box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            width: 50%;

            img {
              width: 100%;
            }
          }
        }

        .list-status {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}

@include mobile {
  .rc-scan-success {
    .rc-container {
      width: 100vw;

      .rc-datetime {
        margin-top: 25px !important;
      }

      .rc-count-checkin {
        font-size: 13px !important;
      }

      .rc-count-checkin-icon {
        display: block !important;
      }

      .code-container {
        padding: 50px 25px !important;
        height: calc(100vh - 50px);

        .entry-code {
          margin-top: 55px !important;

          .code-btn {
            width: 250px;
            height: 50px !important;
            font-size: 13px !important;
          }
        }

        .code-info {
          margin-top: 30px !important;

          .v-btn {
            width: 250px !important;
            color: #fff;
            font-size: 12px !important;
            height: 35px !important;
          }
        }

        .code {
          padding: unset !important;
        }
      }
    }
  }
}
</style>
